// Ambient pulse driver for bioluminescent ground pods. Each pod registers a
// `glowPulse` payload and we ride its shared emissive material with a sine at
// the pod's own rate/phase — so different patches breathe out of sync.

const pulses = [];

export function registerGlowPod(obj) {
  const pulse = obj.userData?.glowPulse;
  if (!pulse) return;
  pulses.push(pulse);
}

export function updateBioLights() {
  const t = performance.now() / 1000;
  for (const p of pulses) {
    const b = 0.5 + 0.5 * Math.sin(t * p.rate + p.phase);
    p.material.emissiveIntensity = p.base + p.amp * b;
  }
}
